import PropTypes from "prop-types"
import { createContext } from "react"
import { useMutation, useQuery } from "react-query"
import {
  createCertification,
  listCertifications,
} from "~/actions/certifications"

const CertificationsContext = createContext()
export default CertificationsContext

export const CertificationsContainer = ({ children }) => {
  const createCertMutation = useMutation(createCertification)

  const { data: certifications, isLoading: certificationsLoading } = useQuery(
    "certifications",
    listCertifications,
  )
  return (
    <CertificationsContext.Provider
      value={{ certifications, certificationsLoading, createCertMutation }}
    >
      {children}
    </CertificationsContext.Provider>
  )
}

CertificationsContainer.propTypes = {
  children: PropTypes.node,
}
